import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import Guide from 'types/Guide';

export async function getPublishedGuides() {
  const response = await API.get(
    apiName,
    `${apiBasePath}/mainaccounts/guides`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.GUIDES,
        domain: DOMAINS.CONTENT,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {},
    },
  );
  return response?.result;
}

const usePublishedGuides = () => {
  const guidesQuery = useQuery<Guide[]>({
    queryKey: [apiName, `publishedGuides`],
    queryFn: () => getPublishedGuides(),
    // options...
  });

  return guidesQuery;
};

export default usePublishedGuides;
